module.exports = __webpack_public_path__ + "static/media/mastercard-minimal.35dc2717.svg";